export function dataToOpts (data, convFunc) {
  let opts = []
  let optsMap = {}

  if (data) {
    data.forEach((e) => {
      let opt = convFunc ? convFunc(e) : e
      opts.push(opt)
      optsMap[e.id] = opt
    })
  }

  return {
    opts: opts,
    optsMap: optsMap
  }
}

export function objToOpts (obj) {
  let opts = []
  let optsMap = {}
  if (obj) {
    Object.keys(obj).forEach((key) => {
      let opt = {
        id: key,
        name: obj[key]
      }
      opts.push(opt)
      optsMap[key] = opt
    })
  }
  return {
    opts: opts,
    optsMap: optsMap
  }
}
